import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=4d5b8d5a&scoped=true&"
import script from "./Selected.vue?vue&type=script&lang=js&"
export * from "./Selected.vue?vue&type=script&lang=js&"
import style0 from "./Selected.vue?vue&type=style&index=0&id=4d5b8d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b8d5a",
  null
  
)

export default component.exports